import { graphql } from "react-relay";

export const CREATE_LICENSES_MUTATION = graphql`
	mutation createLicensesButton_CreateLicensesMutation(
		$input: CreateLicensesInput!
		$connections: [ID!]!
	) {
		Admin {
			Billing {
				createLicenses(input: $input) {
					edges @prependEdge(connections: $connections) {
						node {
							...licensesTable_LicenseFragment
						}
					}
				}
			}
		}
	}
`;
